import { safeDeleteSheet } from "@/lib/office-helpers";

export async function startProject5(): Promise<void> {
  await Excel.run(async (ctx) => {
    // ═══ HOJA 1 – Principales Patrocinadores ═══
    await safeDeleteSheet(ctx, "Principales Patrocinadores");
    const sh5 = ctx.workbook.worksheets.add("Principales Patrocinadores");

    const datos5: (string | number)[][] = [
      ["Principales Patrocinadores", ""],
      ["Nombre del Expositor", "Costo del stand"],
      ["Amigo Dive Boats and Resorts", 3000],
      ["Belize Dive Resort", 3000],
      ["Blue Ocean Gear", 3000],
      ["Fiji Diver Retreat", 3000],
      ["Lionfish Dive and Beach Resort", 3000],
      ["Maldives Diving Treks", 3000],
      ["Pacific Divers", 3000],
      ["Reef Diver Beach Resort", 3000],
      ["SCUBA Tech and Gear", 3000],
      ["SCUBA-wear", 3000],
      ["Ultralight Dive Gear", 3000],
    ];
    sh5.getRangeByIndexes(0, 0, datos5.length, 2).values = datos5;

    sh5.getRange("A1:B1").merge();
    sh5.getRange("A1").format.set({
      horizontalAlignment: "Center",
      font: { bold: true, size: 16 },
    });

    const tbl5 = sh5.tables.add("A2:B13", true);
    tbl5.name = "Patrocinadores";
    tbl5.style = "TableStyleMedium2";
    sh5.getRange("B3:B13").numberFormat = [["$#,##0"]];
    sh5.getUsedRange().format.autofitColumns();
    sh5.activate();

    // ═══ HOJA 2 – Expositores ═══
    await safeDeleteSheet(ctx, "Expositores");
    const sh6 = ctx.workbook.worksheets.add("Expositores");

    const datos6: (string | number)[][] = [
      ["Nombre del Expositor", "Industria", "Ubicación", "Tamaño del Stand"],
      ["Academy of Underwater Photography", "Educación", "E-2", 1000],
      ["Amigo Dive Boats and Resorts", "Viajar", "E-3", 3000],
      ["Belize Dive Resort", "Viajar", "E-1", 3000],
      ["Blue Ocean Gear", "Equipo", "D-6", 3000],
      ["BottomsUp", "Ropa", "D-1", 2000],
      ["Caribean Sports Divers", "Educación", "D-8", 1000],
      ["Deep Blue Wet Suits", "Equipo", "D-3", 2000],
      ["Dive Knives", "Equipo", "C-7", 1000],
      ["Diver Deb", "Ropa", "C-2", 1000],
      ["Dive Knives", "Equipo", "C-7", 1000],
      ["Fiji Diver Retreat", "Viajar", "D-7", 3000],
      ["Freediving Instructors", "Educación", "D-5", 1000],
      ["Guam Diving Tours", "Viajar", "D-4", 2000],
      ["Hammerhead Spearguns", "Equipo", "C-4", 1000],
      ["Island Preservation Institute", "Educación", "D-2", 1000],
      ["Kids Summer Camps", "Educación", "C-6", 1000],
      ["Lionfish Dive and Beach Resort", "Viajar", "C-8", 3000],
      ["Maldives Diving Treks", "Viajar", "C-5", 3000],
      ["Marine Sanctuary Club", "Educación", "C-3", 1000],
      ["Marine Swimwear", "Ropa", "B-6", 2000],
      ["Marine Sanctuary Club", "Educación", "C-3", 1000],
      ["Moby Dick Divers", "Educación", "B-7", 1000],
      ["Nautilus Beach Resort", "Viajar", "C-1", 2000],
      ["Ocean Blue Aqualungs", "Equipo", "B-8", 2000],
      ["Ocean Marine Society", "Educación", "B-2", 1000],
      ["Pacific Divers", "Educación", "A-6", 3000],
      ["Reef Diver Beach Resort", "Viajar", "B-4", 3000],
      ["SCUBA Tech and Gear", "Equipo", "B-3", 3000],
      ["SCUBA-wear", "Ropa", "B-1", 3000],
      ["Sea and See Opticwear", "Equipo", "A-7", 1000],
      ["Sharkskin", "Ropa", "A-5", 1000],
      ["Titan Tours", "Viajar", "A-8", 2000],
      ["Truk Lagoon Dive Resorts", "Viajar", "A-4", 2000],
      ["Ultralight Dive Gear", "Equipo", "A-3", 3000],
      ["Video Underwater Specialists", "Educación", "A-2", 1000],
      ["Women's Divewear", "Ropa", "A-1", 2000],
    ];

    sh6.getRange("A1:D1").merge();
    sh6.getRange("A1").values = [
      ["Expositores de convenciones de buceo"],
    ];
    sh6.getRange("A1").format.set({
      horizontalAlignment: "Center",
      font: { bold: true, size: 16 },
    });

    sh6.getRangeByIndexes(1, 0, datos6.length, 4).values = datos6;

    const tbl6 = sh6.tables.add(
      sh6.getRangeByIndexes(1, 0, datos6.length, 4),
      true
    );
    tbl6.name = "ExpositoresTbl";
    tbl6.style = "TableStyleMedium2";
    sh6.getRange(`D3:D${datos6.length + 1}`).numberFormat = [["$#,##0"]];
    sh6.getUsedRange().format.autofitColumns();

    // ═══ HOJA 3 – Horario de Sesiones ═══
    await safeDeleteSheet(ctx, "Horario de Sesiones");
    const sh7 = ctx.workbook.worksheets.add("Horario de Sesiones");

    const datos7: (string | number)[][] = [
      ["Título de Sesión", "Día", "Tiempo", "Habitación", "Seguimiento"],
      ["Cómo aprovechar las aplicaciones móviles", "Miércoles", "10:00 AM", 100, "Marketing"],
      ["Convertirse en una tienda de buceo superior", "Miércoles", "10:00 AM", 200, "Operaciones"],
      ["Medios de comunicación social 101 ¿Por qué usarlos?", "Jueves", "10:00 AM", 100, "Marketing"],
      ["Atraer a los instructores talentosos", "Jueves", "10:00 AM", 200, "Operaciones"],
      ["Uso de instructores para verder de forma flexible", "Jueves", "10:00 AM", 300, "Ventas"],
      ["Involucrar a los jóvenes en el buceo", "Viernes", "10:00 AM", 100, "Marketing"],
      ["Sabiduría a través de los años", "Viernes", "10:00 AM", 200, "Ventas"],
      ["Seguimiento de las certificaciones de los estudiantes", "Viernes", "10:00 AM", 300, "Operaciones"],
      ["Aprovechamiento de los accesorios de buceo", "Sábado", "10:00 AM", 100, "Ventas"],
      ["Adquirir referencias de estudiantes", "Sábado", "10:00 AM", 200, "Marketing"],
      ["Mantener a los clientes felices", "Miércoles", "11:00 AM", 100, "Ventas"],
      ["Buceo en la playa", "Miércoles", "11:00 AM", 200, "Marketing"],
      ["Cinco elementos esenciales de ventas", "Jueves", "11:00 AM", 100, "Ventas"],
      ["El negocio de los viajes de buceo", "Jueves", "11:00 AM", 200, "Ventas"],
      ["Promover clases avanzadas de buceo", "Jueves", "11:00 AM", 300, "Marketing"],
      ["Formas de procesar los pagos", "Viernes", "11:00 AM", 100, "Operaciones"],
      ["Estrategias para la comercialización en línea", "Viernes", "11:00 AM", 200, "Marketing"],
      ["Cómo beneficiarse de descuentos", "Viernes", "11:00 AM", 300, "Ventas"],
      ["Gestión de los horarios del curso", "Sábado", "11:00 AM", 100, "Operaciones"],
      ["¿Las ventas anuales son rentables?", "Sábado", "11:00 AM", 200, "Marketing"],
      ["Impresionantes campañas de correo electrónico", "Miércoles", "1:00 PM", 100, "Marketing"],
      ["Beneficios de la propiedad de la tienda de buceo", "Miércoles", "1:00 PM", 200, "Operaciones"],
      ["El poder de YouTube y Vimeo", "Jueves", "1:00 PM", 100, "Marketing"],
      ["Construyendo talento para el futuro", "Jueves", "1:00 PM", 200, "Operaciones"],
      ["Técnicas ventas efectivas", "Jueves", "1:00 PM", 300, "Ventas"],
      ["Herramientas de medios sociales gratis para buceo", "Viernes", "1:00 PM", 100, "Marketing"],
      ["¡Pare, piense, administre!", "Viernes", "1:00 PM", 200, "Operaciones"],
      ["Cierre grandes ofertas", "Viernes", "1:00 PM", 300, "Ventas"],
      ["Tendencias al por menor", "Miércoles", "2:00 PM", 100, "Marketing"],
      ["Nuevas leyes laborales para el buceo", "Miércoles", "2:00 PM", 200, "Operaciones"],
      ["Colaborar para crear negocios", "Jueves", "2:00 PM", 100, "Marketing"],
      ["Estrategias de retención del personal", "Jueves", "2:00 PM", 200, "Operaciones"],
      ["Nuevos equipos", "Jueves", "2:00 PM", 300, "Ventas"],
      ["Equipo de buceo para niños", "Viernes", "2:00 PM", 100, "Ventas"],
      ["Cómo ejecutar un campamento de verano para niños", "Viernes", "2:00 PM", 200, "Operaciones"],
      ["Marketing a las familias", "Viernes", "2:00 PM", 300, "Marketing"],
      ["Obtener clientes que toquen a tu puerta", "Miércoles", "3:00 PM", 100, "Ventas"],
      ["Venta efectiva en Internet", "Miércoles", "3:00 PM", 200, "Marketing"],
      ['¿Puedo ayudarte?" - Estrategias de venta al por menor', "Jueves", "3:00 PM", 100, "Ventas"],
      ["Éxito con Google AdWords", "Jueves", "3:00 PM", 200, "Marketing"],
      ["Cómo evitar el arrastre del presupuesto", "Jueves", "3:00 PM", 300, "Operaciones"],
      ["Cómo organizar y vender viajes de buceo", "Viernes", "3:00 PM", 100, "Ventas"],
      ["Adquirir revisiones online efectivas", "Viernes", "3:00 PM", 200, "Marketing"],
      ["Evitar el agotamiento del buceo", "Viernes", "3:00 PM", 300, "Operaciones"],
    ];

    sh7.getRange("A1:E1").merge();
    sh7.getRange("A1").values = [
      ["Calendario de Sesiones de la Convención de Buceo"],
    ];
    sh7.getRange("A1").format.set({
      horizontalAlignment: "Center",
      font: { bold: true, size: 16 },
    });
    sh7.getRange("F1").values = [["Última Actualización:"]];

    sh7.getRangeByIndexes(1, 0, datos7.length, 5).values = datos7;

    const tbl7 = sh7.tables.add(
      sh7.getRangeByIndexes(1, 0, datos7.length, 5),
      true
    );
    tbl7.name = "HorarioSesionesTbl";
    tbl7.style = "TableStyleMedium2";
    sh7.getUsedRange().format.autofitColumns();

    // ═══ HOJA 4 – Horario Diario (Pivot Table) ═══
    await safeDeleteSheet(ctx, "Horario Diario");
    const sh8 = ctx.workbook.worksheets.add("Horario Diario");

    const srcTbl8 = ctx.workbook.tables.getItem("HorarioSesionesTbl");
    const srcRng8 = srcTbl8.getRange();

    const pvt8 = sh8.pivotTables.add(
      "pvtHorarioDia",
      srcRng8,
      sh8.getRange("A3")
    );

    pvt8.hierarchies.load("items/name");
    await ctx.sync();

    const addRow8 = (hName: string) =>
      pvt8.rowHierarchies.add(pvt8.hierarchies.getItem(hName));

    addRow8("Día");
    addRow8("Seguimiento");
    addRow8("Título de Sesión");

    pvt8.dataHierarchies.add(
      pvt8.hierarchies.getItem("Título de Sesión")
    );

    sh8.getRange("D3").values = [
      ["Número de Sesiones de Marketing el Jueves:"],
    ];

    sh8.getUsedRange().format.autofitColumns();
    sh8.activate();

    await ctx.sync();
  });
}
